export const C3_LS3_PROD = 'https://personal1.vanguard.com/ls3-ccc-logger-webservice/api/log';
export const C3_LS3_NON_PROD = 'https://satpersonal1.vanguard.com/ls3-ccc-logger-webservice/api/log';

export const C3_LAA_COOKIE_DROP_PROD = 'https://personal1.vanguard.com/api/laa-ret-etm-adobe-launch-webapp/cookieDrop';
export const C3_LAA_COOKIE_DROP_NON_PROD = 'https://satpersonal1.vanguard.com/api/laa-ret-etm-adobe-launch-webapp/cookieDrop';
